import actions from "./actions"
import { mutations } from "./mutations"
import getters from "./getters"
import { LeadsState, getInitialLeadsState } from "@/models/LeadsState"

export default {
	namespaced: true,
	state: (): LeadsState => getInitialLeadsState(),
	mutations,
	actions,
	getters
}
